import { extractOdomPosition, extractOdomRotation } from "../types/ar-types.js";
//#region ../src/ar/captured-camera-frame.ts
/**
* A camera frame paired with the camera pose and time of its capture.
* See captured-camera-frame.ts.md.
*/
/** Reshape an ARPose ({x,y,z} / {x,y,z,w} objects) into Pose tuples. */
function poseFromArPose(arPose) {
	return {
		position: extractOdomPosition(arPose),
		rotation: extractOdomRotation(arPose)
	};
}
/**
* Build the frame, or `null` when there is no pose for it - an unpaired frame
* must not be delivered, because every consumer would solve it against a
* different moment.
*
* @param xrTimeMs - the XR animation-frame time (page-relative ms).
* @param timeOriginMs - `performance.timeOrigin`; injectable for tests.
*/
function capturedCameraFrame(image, arPose, xrTimeMs, timeOriginMs) {
	if (!arPose) return null;
	return {
		image,
		cameraPose: poseFromArPose(arPose),
		capturedAtMs: timeOriginMs + xrTimeMs
	};
}
//#endregion
export { capturedCameraFrame, poseFromArPose };
